export const LayoutUrls = {
  ChangePassword: '/api/user/changepassword',
  VerifyPassword: '/api/user/verifypass',
  CustomerAccounts: '/api/customeraccount',
};


